import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { AppWizService } from './app-wiz.service';
import { UiStoreService } from './ui-store.service';
import { ARTIFACTS_ACCEPTANCE } from '../constants/artifacts-order.constants';
import { Artifact } from '../models/artifact.model';
import { CertWizService } from './cert-wiz.service';
import { ARTIFACT_STATUS } from '../enums/artifact.enum';

@Injectable({
  providedIn: 'root'
})
export class AppWizUiService {

  constructor(
    public userService: UserService,
    public appWizService: AppWizService,
    public certWizService: CertWizService,
    public uiStoreService: UiStoreService,
  ) {  }

  artifactsByRole(isApplicant:boolean, artifacts:Artifact[]){
    const userRole = this.userService.getSelectedSiteRole()?.RoleName;
    return artifacts
    .filter(i=>isApplicant ? i.role == 'Applicant': i.role == userRole);
  }
  artifactsByRoleWithoutAcceptance(isApplicant:boolean, artifacts:Artifact[]){
    return this.artifactsByRole(isApplicant, artifacts)
    .filter(i=>!ARTIFACTS_ACCEPTANCE.includes(i.key));
  }
  getAcceptanceArtifact(isApplicant:boolean, artifacts:Artifact[]){
    const userRole = this.userService.getSelectedSiteRole()?.RoleName;
    return artifacts
    .filter(i=>isApplicant ? i.role == 'Applicant': i.role == userRole)
    .find(i=>ARTIFACTS_ACCEPTANCE.includes(i.key));
  }
  getSelectedArtifact(artifacts:Artifact[]){
    return artifacts.find(i=>i.artifactId == this.uiStoreService.expandedArtifactId.value);
  }
  isAcceptanceArtifactSelected(artifacts:Artifact[]){
    return ARTIFACTS_ACCEPTANCE.includes(this.getSelectedArtifact(artifacts)?.key || "");
  }
  isAnyArtifactPending(isApplicant:boolean, artifacts:Artifact[]){
    return this.artifactsByRoleWithoutAcceptance(isApplicant, artifacts).some(i=>{
      return ![ARTIFACT_STATUS.PACKAGECOMPLETE,ARTIFACT_STATUS.COMPLETE].includes(i.artifactStatus);
    });
  }
  isAcceptanceArtifactPending(isApplicant:boolean, artifacts:Artifact[]){
    let acceptanceArtifact = this.getAcceptanceArtifact(isApplicant, artifacts);
    return !(acceptanceArtifact && [ARTIFACT_STATUS.PACKAGECOMPLETE,ARTIFACT_STATUS.COMPLETE].includes(acceptanceArtifact?.artifactStatus || ARTIFACT_STATUS.COMPLETE));
  }

}
